import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import StickyBox from 'react-sticky-box';
import dynamic from 'next/dynamic';

import { SkeletonWrapper, Skeleton } from '../../atoms/skeleton';
import { SortByDesktop, items } from './sort-by';
import Categories, { attributes } from './hierarchical-menu';
import PetiteProfile from './petite';
import Refinements from './refinements';

const ScrollToTop = dynamic(() => import('../../tissues/back-to-top'));

const Facets = styled(StickyBox)(({ theme }) => ({
  alignSelf: 'flex-start',
  display: 'none',
  marginRight: '5rem',
  minWidth: '25%',
  '> section': {
    marginBottom: '5rem'
  },
  [`@media screen and (min-width: ${theme.breakpoint.medium})`]: {
    display: 'block'
  }
}));

const Wrapper = styled(SkeletonWrapper)(() => ({
  alignItems: 'center',
  display: 'flex',
  flexDirect: 'column',
  [Skeleton]: {
    '&:nth-of-type(1)': {
      marginBottom: '5rem',
      height: '8rem',
      width: '100%'
    },
    '&:nth-of-type(2)': {
      marginBottom: '5rem',
      height: '40rem',
      width: '100%'
    },
    '&:nth-of-type(3)': {
      marginBottom: '5rem',
      height: '30rem',
      width: '100%'
    }
  }
}));

export const RefinementsSkeleton = (props) => (
  <Facets offsetTop={200} as="aside">
    <Wrapper {...props}>
      <Skeleton />
      <Skeleton />
      <Skeleton />
    </Wrapper>
  </Facets>
);

const LeftRail = (props) => (
  <Facets offsetTop={200} as="aside" {...props}>
    <PetiteProfile />

    <SortByDesktop
      defaultRefinement={process.env.NEXT_PUBLIC_ALGOLIA_PRODUCTS_INDEX}
      items={items}
    />

    <Refinements isBrandRefined={props.isBrandRefined} />

    <Categories attributes={attributes} />
    <ScrollToTop />
  </Facets>
);

LeftRail.defaultProps = {
  isBrandRefined: false
};

LeftRail.propTypes = {
  isBrandRefined: PropTypes.bool
};

export default LeftRail;
